import {
  BuildJsonType,
  Country,
  EnhancedAppointment,
} from '@bb/domain/dist/types';
import { Button, theme } from 'components';
import * as React from 'react';
import styled from 'styled-components';
import Covid19AckTemplate from './COVID19AckTemplate';
import CovidSigning from './CovidSigning';
import { AcknowledgmentModal } from './StyledComponents';

interface CovidAckTemplateModalProps {
  ackTemplate: string;
  appointment: BuildJsonType<EnhancedAppointment>;
  country: Country;
  onCancel: () => void;
  onSubmit: (signature: string) => Promise<void>;
  visible: boolean;
}

const CovidAckTemplateModal: React.FC<CovidAckTemplateModalProps> = ({
  ackTemplate,
  appointment,
  country,
  onCancel,
  onSubmit,
  visible,
}) => {
  const [signature, setSignature] = React.useState('');
  const signDivRef = React.useRef(null);

  const scrollToSign = () => {
    signDivRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <StyledModal
      centered
      open={visible}
      footer={null}
      closable={false}
      onCancel={onCancel}
      zIndex={4001} // Needs to be bigger than TourListingModal to avoid overlap
    >
      <ModalTitleDiv>
        <CursorPointerSpan onClick={onCancel}>X</CursorPointerSpan>
        <CursorPointerSpan onClick={scrollToSign}>
          {!signature ? `Start` : `Finish`}
        </CursorPointerSpan>
      </ModalTitleDiv>

      <StyledModalContent>
        <Covid19AckTemplate
          appointment={appointment}
          ackTemplate={ackTemplate}
          country={country}
        />

        <SignHereDiv>
          <div ref={signDivRef}>Sign here: </div>
          <CovidSigning setSignature={setSignature} signature={signature} />
        </SignHereDiv>

        <CenteredDiv>
          <Button
            disabled={!signature}
            type="primary"
            onClick={() => onSubmit(signature)}
          >
            Finish
          </Button>
        </CenteredDiv>
      </StyledModalContent>
    </StyledModal>
  );
};

const StyledModal = styled(AcknowledgmentModal).attrs({
  bodyStyle: { padding: 0 },
})``;

const StyledModalContent = styled.div`
  overflow-y: auto;
  max-height: 80vh;
  padding: 0px ${theme.modalBodyPadding} ${theme.modalBodyPadding};
`;

const CursorPointerSpan = styled.span`
  &:hover {
    cursor: pointer;
  }
`;

const ModalTitleDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1890ff;
  color: white;
  padding: 7px 15px;
`;

const SignHereDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
  * {
    margin-right: 6px;
  }
`;
const CenteredDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

export default CovidAckTemplateModal;
